// Arabic-Indic digit conversion for user-facing numbers.
//
// Three helpers:
//
//   toArabicDigits(value)
//     Unconditionally converts Western digits (0-9) → Arabic-Indic (٠-٩).
//     Use only when the surrounding text is guaranteed to be Arabic
//     (e.g. legacy Arabic-only copy). Locale-blind.
//
//   toWesternDigits(value)
//     Inverse — Arabic-Indic → Western. For backend submissions where
//     digits must be ASCII.
//
//   localizedDigits(value, language)
//     Locale-aware. Returns Arabic-Indic when language starts with 'ar';
//     otherwise returns Western digits (normalising any Arabic-Indic
//     that may have leaked in from legacy data). This is the one to
//     use in shared components like the browse profile card so English
//     users see "32" and Arabic users see "٣٢".
//
// Non-digit characters pass through unchanged. null/undefined → ''.

const ARABIC_INDIC = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
const WESTERN_FROM_ARABIC = {
  '٠': '0', '١': '1', '٢': '2', '٣': '3', '٤': '4',
  '٥': '5', '٦': '6', '٧': '7', '٨': '8', '٩': '9',
};

export function toArabicDigits(value) {
  if (value === null || value === undefined) return '';
  return String(value).replace(/[0-9]/g, (d) => ARABIC_INDIC[parseInt(d, 10)]);
}

export function toWesternDigits(value) {
  if (value === null || value === undefined) return '';
  return String(value).replace(/[٠-٩]/g, (d) => WESTERN_FROM_ARABIC[d] || d);
}

export function localizedDigits(value, language) {
  if (value === null || value === undefined) return '';
  const lang = String(language || 'ar').toLowerCase();
  if (lang.startsWith('ar')) return toArabicDigits(value);
  return toWesternDigits(value);
}
